import script from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=e27ad622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e27ad622"]])

export default __exports__